import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { TextVariants } from "../../index";
import { Text as ThemeText } from "theme-ui";
export const Label2 = props => {
    return (_jsx(ThemeText, Object.assign({ sx: { variant: `text.${TextVariants.label2}` } }, props)));
};
export default Label2;
//# sourceMappingURL=Label2.js.map